import { createContext, useContext, useState, ReactNode } from "react"
import { EsoClient } from "@/types"

interface ViewerContextType {
  viewedClient: EsoClient | null
  setViewedClient: (client: EsoClient | null) => void
  isViewingAsClient: boolean
}

const ViewerContext = createContext<ViewerContextType>({
  viewedClient: null,
  setViewedClient: () => {},
  isViewingAsClient: false,
})

export const ViewerProvider = ({ children }: { children: ReactNode }) => {
  const [viewedClient, setViewedClient] = useState<EsoClient | null>(null)

  return (
    <ViewerContext.Provider value={{ viewedClient, setViewedClient, isViewingAsClient: viewedClient !== null }}>
      {children}
    </ViewerContext.Provider>
  )
}

export const useViewer = () => useContext(ViewerContext)
